// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Grace_RevokeInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Grace_RevokeInput — body for POST /subscriptions/grace/revoke.
 *
 * Required: grace_id (positive int identifying the franchises_grace_periods row).
 * Optional: reason (string note written to the revoked row).
 */
import { registerContract } from './validate'

export interface Grace_RevokeInput {
grace_id: number
reason?: string
}

registerContract('Grace_RevokeInput', {
  grace_id: { type: 'number',  required: true },
  reason:   { type: 'string',  required: false },
})
